import FocusComingSoon from "./FocusComingSoon";
import TasksFocus from "@/components/layouts/TasksFocus/TasksFocus";
import React from "react";

const FocusTab: React.FC = () => {
  return (
    <div data-test="focus-tab" className="flex flex-col gap-6 p-6">
      <TasksFocus />
      <FocusComingSoon />
    </div>
  );
};

export default FocusTab;
